const C = require("../constants");
const initial_data = {open: false, tax:{id:null, name:'', percentage:0}};

function ProviderDialogReducer(state = initial_data, action) {
    switch (action.type) {
        case C.TAX_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default ProviderDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/TaxDialogReducer.js